module.exports = __webpack_public_path__ + "static/login-app-636b0a51a5f73d031bc03efc72d9094a.jpg";